export type StatusTone = 'good' | 'warning' | 'bad' | 'neutral';

const capabilityLabels: Record<string, string> = {
  conversation: 'المحادثة النصية',
  liveVoice: 'المكالمة الصوتية',
  memoryCandidatePersistence: 'حفظ مرشح الذاكرة',
  memoryExtraction: 'استخراج الذاكرة',
  initiatives: 'المبادرات والإشعارات',
  pushNotifications: 'إشعارات الويب',
  externalBackup: 'النسخ الخارجي'
};

/** Phrasing that is specific to a capability and status pair. */
const specificMessages: Record<string, Partial<Record<string, string>>> = {
  conversation: { awaiting_credentials: 'بانتظار بيانات اعتماد الذكاء الاصطناعي' },
  liveVoice: { awaiting_credentials: 'بانتظار بيانات اعتماد المزود' },
  externalBackup: { awaiting_credentials: 'بانتظار بيانات الاعتماد' },
  initiatives: { locally_verified_simulator_only: 'متحقق محليًا — بالمحاكي، بانتظار مزود حي' },
  pushNotifications: { awaiting_credentials: 'بانتظار تهيئة مفاتيح الإشعارات' }
};

function valueMessage(value: string): string {
  if (value === 'available') return 'متاح';
  if (value === 'unavailable') return 'غير متاح';
  if (value === 'not_implemented') return 'غير منفذ';
  if (value === 'awaiting_credentials') return 'بانتظار بيانات الاعتماد';
  if (value === 'configured_unverified') return 'مفعّل — بانتظار تحقق حي';
  if (value.startsWith('locally_verified')) return 'متحقق محليًا';
  if (value === 'degraded') return 'متدهور';
  return 'بانتظار التحقق';
}

function toneFor(value: string): StatusTone {
  if (value === 'available' || value.startsWith('locally_verified')) return 'good';
  if (value === 'unavailable' || value === 'degraded') return 'bad';
  if (value === 'awaiting_credentials' || value === 'configured_unverified' || value === 'not_implemented') return 'warning';
  return 'neutral';
}

const readinessLabels: Record<string, string> = {
  api: 'واجهة API',
  database: 'قاعدة البيانات',
  schema: 'مخطط قاعدة البيانات',
  worker: 'عامل المهام'
};

export function capabilityPresentation(key: string, value: string): { label: string; message: string; tone: StatusTone } {
  return {
    label: capabilityLabels[key] ?? 'قدرة غير معنونة',
    message: specificMessages[key]?.[value] ?? valueMessage(value),
    tone: toneFor(value)
  };
}

export function readinessLabel(key: string): string {
  return readinessLabels[key] ?? 'فحص الجاهزية';
}
